import { isAdmin } from '../../utils/helpers';
import AdminTopNav from './AdminTopNav';
import MerchantTopNav from './MerchantTopNav';

const TopNav = isAdmin() ? AdminTopNav : MerchantTopNav;
export default TopNav;
